export const kPtOverlay3: Record<string, string> = {
  hsm_hi_level_r_hint: 'Gerar um alerta crítico quando pelo menos esta percentagem dos canais HSM estiver em utilização',
  hsm_lo_level_r_label: 'Utilização de canais: Aviso ([0-100]%)',
  hsm_lo_level_r_hint: 'Gerar um alerta de aviso quando pelo menos esta percentagem dos canais HSM estiver em utilização',
  login_terminal_label: 'Restrição por cliente',
  login_terminal_tooltip: 'Acesso autorizado se o identificador do cliente estiver registado na base de dados',
  login_term_ssl_label: 'Nome SSL registado',
  login_term_ssl_tooltip: 'O nome SSL também tem de estar registado na base de dados',
  login_term_ip_label: 'IP registado',
  login_term_ip_tooltip: 'O endereço IP também tem de estar registado na base de dados',
  login_term_match_ip_label: 'Correspondência de IP',
  login_term_match_ip_tooltip: 'O IP que se liga tem de corresponder ao IP registado para este cliente na base de dados',
  login_ip_label: 'Restrição por IP',
  login_ip_tooltip: 'Acesso autorizado se o IP do cliente estiver registado na base de dados',
  login_ip_term_label: 'Cliente registado',
  login_ip_term_tooltip: 'O identificador do cliente também tem de estar registado na base de dados',
  login_ip_ssl_label: 'Nome SSL registado',
  login_ip_ssl_tooltip: 'O nome SSL também tem de estar registado na base de dados',
  login_ip_match_ssl_label: 'Correspondência de nome SSL',
  login_ip_match_ssl_tooltip: 'O nome SSL que se liga tem de corresponder ao nome SSL registado para este cliente na base de dados',
  login_ssl_label: 'Restrição por nome SSL',
  login_ssl_tooltip: 'Acesso autorizado se o nome SSL estiver registado na base de dados',
  login_ssl_term_label: 'Cliente registado',
  login_ssl_term_tooltip: 'O identificador do cliente também tem de estar registado na base de dados',
  login_ssl_ip_label: 'IP registado',
  login_ssl_ip_tooltip: 'O endereço IP também tem de estar registado na base de dados',
  alert_delay_s_label: 'Atraso de alertas',
  alert_delay_s_hint: 'Atraso entre relatórios de alerta',
  alert_delay_s_tooltip: 'Atraso mínimo antes de enviar um novo email para comunicar alertas com prioridade igual ou inferior à anterior. Os alertas de prioridade mais elevada continuarão a ser comunicados imediatamente.',
  smtp_server_label: 'Servidor SMTP: IP ou endereço',
  smtp_server_hint: 'SMTP: Acesso 1/2',
  smtp_port_label: 'Servidor SMTP: Porta',
  smtp_port_hint: 'SMTP: Acesso 2/2',
  smtp_login_label: 'Servidor SMTP: Início de sessão',
  smtp_login_hint: 'SMTP: Credenciais 1/2',
  smtp_pwd_label: 'Servidor SMTP: Palavra-passe',
  smtp_pwd_hint: 'SMTP: Credenciais 2/2',
  during: 'Durante',
  last_co: 'Última lig.',
  clName_already_used: 'Identificador de cliente já registado',
  fromOrigin: 'De',
  prevBalance: 'Saldo ant.',
  amount: 'Montante',
  sam_whitelist: 'Lista branca SAM',
  hsm_history: 'Histórico HSM',
  permission: 'Permissão',
  permissions: 'Permissões',
  debit: 'Débito',
  debits: 'Débitos',
  credit: 'Crédito',
  credits: 'Créditos',
  timeout: 'Tempo limite',
  server_error: 'Erro do servidor',
  server_fail: 'Falha do servidor',
  server_failure: 'Falha do servidor',
  portable_object_error: 'Erro de objeto portátil',
  portable_object_fail: 'Falha de objeto portátil',
  portable_object_failure: 'Falha de objeto portátil',
  invalid_session_mac: 'MAC de sessão inválido',
  invalid_content: 'Conteúdo inválido',
  expired: 'Expirado',
  terminal_error: 'Erro do terminal',
  terminal_fail: 'Falha do terminal',
  terminal_failure: 'Falha do terminal',
  blacklisted_sam: 'SAM em lista negra',
  entryEnabled: 'Ativado',
  entryDisabled: 'Desativado',
  entryActive: 'Ativo',
  entryInactive: 'Inativo',
  hidden: 'Oculto',
  displayed: 'Apresentado',
  network_hidden: 'Rede oculta',
  network_displayed: 'Rede apresentada',
  page_not_found: 'Página não encontrada',
  displayAction: 'Apresentar',
  network_saved: 'Rede guardada',
  network_registered: 'Rede registada',
  network_updated: 'Rede atualizada',
  from: 'De',
  to: 'Até',
  heavyOperationWarning: 'Operação que consome tempo e recursos',
  bigFileExportWarning: 'A exportação de uma grande quantidade de dados pode ser limitada pelos serviços de alojamento da base de dados/servidor. ',
  toExport: 'Exportar',
  refine_the_search: 'Refinar a pesquisa',
  reset_this_form_: 'Repor este formulário?',
  reset_form: 'Repor formulário',
  nfc_server: 'Servidor NFC',
  monitoring: 'Monitorização',
  server_not_monitored: 'Servidor não monitorizado',
  block: 'Bloco',
  blocks: 'Blocos',
  network_deactivated: 'Rede desativada',
  network_activated: 'Rede ativada',
  select_this_alert: 'Selecionar este alerta',
  deselect_this_alert: 'Anular seleção deste alerta',
  select_all_alerts_on_this_page: 'Selecionar todos os alertas desta página',
  deselect_all_alerts_on_this_page: 'Anular seleção de todos os alertas desta página',
  deselect_alerts_on_all_pages: 'Anular seleção dos alertas em todas as páginas',
  alertNo: 'Nenhum',
  alertNone: 'Nenhum',
  _on_this_page: ' nesta página',
  _alert_selected: ' alerta selecionado',
  _alerts_selected: ' alertas selecionados',
  portable_object: 'Objeto portátil',
  portable_objects: 'Objetos portáteis',
  toggle_to_activate: 'Alternar para ativar',
  toggle_to_deactivate: 'Alternar para desativar',
  add: 'Adicionar',
  toAdd: 'Adicionar',
  please_select_a_network_first: 'Selecione primeiro uma rede',
  please_select_a_network_with_a_group_first: 'Selecione primeiro uma rede com um grupo',
  this_authorisation_is_already_in_the_list: 'Esta autorização já está na lista',
  iso_timings: 'Tempos ISO',
  importAction: 'Importar',
  file: 'Ficheiro',
  files: 'Ficheiros',
  range: 'Intervalo',
  ranges: 'Intervalos',
  import_from_a_file: 'Importar a partir de um ficheiro',
  whitelist_saved: 'Lista branca guardada',
  remove_this_range__: 'Remover este intervalo?',
  range_removed: 'Intervalo removido',
  byte: 'Byte',
  integer: 'Inteiro',
  string: 'Cadeia',
  parameter_saved: 'Parâmetro guardado',
  parameter_removed: 'Parâmetro removido',
  remove_this_parameter__: 'Remover este parâmetro?',
  remove_this_account__: 'Remover esta conta?',
  account_deactivated: 'Conta desativada',
  account_activated: 'Conta ativada',
  account_saved: 'Conta guardada',
  account_removed: 'Conta removida',
  account_updated: 'Conta atualizada',
  accounts_updated: 'Contas atualizadas',
  subscriptions: 'Subscrições',
  localization: 'Localização',
  timezone: 'Fuso horário',
  lang: 'Idio',
  time: 'Tempo',
  total: 'Total',
  sv_reloads: 'Recargas SV',
  reloads: 'Recargas',
  sv_loads: 'Carregamentos SV',
  success__percent: 'Sucesso (%)',
  error__percent: 'Erro (%)',
  fail__percent: 'Falha (%)',
  failure__percent: 'Falha (%)',
  last_2_days: 'Últimos 2 dias',
  over_1_day: 'Mais de 1 dia',
  over_2_days: 'Mais de 2 dias',
  over_7_days: 'Mais de 7 dias',
  over_30_days: 'Mais de 30 dias',
  over_90_days: 'Mais de 90 dias',
  over_180_days: 'Mais de 180 dias',
  over_365_days: 'Mais de 365 dias',
  pervious_day: 'Dia anterior',
  pervious_2_days: '2 dias anteriores',
  pervious_7_days: '7 dias anteriores',
  pervious_30_days: '30 dias anteriores',
  transactions_statistics: 'Estatísticas de transações',
  activity: 'Atividade',
  currently: 'Atualmente',
  avg__duration: 'Duração méd.',
  avg__duration__ms_: 'Duração méd. (ms)',
  logged_in: 'Com sessão iniciada',
  archive_all_alerts: 'Arquivar todos os alertas',
  all_alerts_have_been_archived: 'Todos os alertas foram arquivados',
  some_alerts_have_been_archived: 'Alguns alertas foram arquivados',
  some_alerts_have_been_resolved: 'Alguns alertas foram resolvidos',
  some_alerts_have_been_set_in_progress: 'Alguns alertas foram definidos em curso',
  some_alerts_have_been_reset: 'Alguns alertas foram repostos',
  alerts_reset: 'Alertas repostos',
  set_alerts_in_progress: 'Definir alertas em curso',
  resolve_alerts: 'Resolver alertas',
  archive_alerts: 'Arquivar alertas',
  alerts_updated: 'Alertas atualizados',
  alerts_all_archived: 'Todos os alertas arquivados',
  whitelist_updated: 'Lista branca atualizada',
  whitelist_entries_registered: 'Entradas da lista branca registadas',
  whitelist_entries_removed: 'Entradas da lista branca removidas',
  parameters_updated: 'Parâmetros atualizados',
  parameter_updated: 'Parâmetro atualizado',
  previous_day: 'Dia anterior',
  previous_2_days: '2 dias anteriores',
  previous_7_days: '7 dias anteriores',
  previous_30_days: '30 dias anteriores',
  since_yesterday: 'Desde ontem',
  since_2_days: 'Desde há 2 dias',
  since_7_days: 'Desde há 7 dias',
  since_30_days: 'Desde há 30 dias',
  since_90_days: 'Desde há 90 dias',
  since_180_days: 'Desde há 180 dias',
  since_365_days: 'Desde há 365 dias',
  loaded: 'Carregado',
  done: 'Concluído',
  failed: 'Falhado',
  done__acknowledged_: 'Concluído (Confirmado)',
  done__not_acknowledged_: 'Concluído (Não confirmado)',
  loaded__acknowledged_: 'Carregado (Confirmado)',
  loaded__not_acknowledged_: 'Carregado (Não confirmado)',
  refund__automatic_: 'Reembolso (Automático)',
  refund__customer_support_: 'Reembolso (Apoio ao cliente)',
  refund__cs_: 'Reembolso (AC)',
  cancelled: 'Cancelado',
  purchase_start: 'Início da compra',
  purchase_stop: 'Fim da compra',
  purchase_status: 'Estado da compra',
  purchase_status_since: 'Estado da compra desde',
  load_status: 'Estado do carregamento',
  load_start: 'Início do carregamento',
  load_stop: 'Fim do carregamento',
  refund: 'Reembolso',
  refunds: 'Reembolsos',
  quantity: 'Quantidade',
  quantities: 'Quantidades',
  reference: 'Referência',
  references: 'Referências',
  purchase_ok: 'Compra OK',
  purchase_err_: 'Compra erro',
  purchase_fail: 'Falha da compra',
  purchase_failure: 'Falha da compra',
  load_ok: 'Carregamento OK',
  load_err_: 'Carregamento erro',
  load_fail: 'Falha do carregamento',
  load_failure: 'Falha do carregamento',
  loads_ok: 'Carregamentos OK',
  loads_err_: 'Carregamentos erro',
  loads_fail: 'Falha dos carregamentos',
  loads_failure: 'Falha dos carregamentos',
  sale: 'Venda',
  sales: 'Vendas',
  purchase_id: 'ID da compra',
  undefined: 'Indefinido',
  undetermined: 'Indeterminado',
  reloading_failed: 'Recarga falhada',
  millisecond: 'Milissegundo',
  milliseconds: 'Milissegundos',
  second: 'Segundo',
  seconds: 'Segundos',
  minute: 'Minuto',
}
